export default "__VITE_ASSET__CH8Hm34I__"